import React, { ChangeEvent } from "react";
import { connect } from "react-redux";
import {
    Typography,
    IconButton,
    WithStyles,
    withStyles,
    Grid,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Checkbox,
    Button,
    Collapse,
    CircularProgress,
} from "material-ui";

import { ReduxState, ReduxDispatch } from "../../ducks/reducers";
import { RouterProps } from "react-router";
import {
    SetShowBackNavigation,
    ShowBackNavigationWithRoute,
    SetHeader,
} from "../../ducks/common";
import EditProfileForm, {
    editProfileFormName,
} from "./components/EditProfileForm";
import {
    fetchProfileData,
    toggleEditProfile,
    saveProfileData,
    getAmlStatus,
} from "../../ducks/profile";
import { saveKYCData, fetchKYCData, getInitialKycData } from "../../ducks/kyc";
import {
    AmlRiskAssesmentStatusType,
    IProfileDataDto,
} from "../../util/DTOs/ProfileDtos";
import { removeLoginCredentials } from "ducks/user";
import { autoCompletePostalCity, getPostalCodes } from "ducks/postalcodes";
import { clearSecureStorage } from "util/storage";
import { IsCordova } from "util/platformUtils";
import { showSnackbar } from "ducks/snackbar";
import { GridDivider } from "components/GridDivider/GridDivider";
import { ArrowIcon, ArrowIconOrientation } from "components/Icons/ArrowIcon";
import CustomCheckboxIcon from "components/CustomCheckbox/CustomCheckboxIcon";
import CustomCheckboxIconChecked from "components/CustomCheckbox/CustomCheckboxIconChecked";
import CustomPenIcon from "components/CustomPenIcon/CustomPenIcon";
import { KYCDataDto, KycDto, KycQuestionAnswer } from "util/DTOs/KYCDtos";
import moment from "moment";
import {
    autoScroll,
    getAccessibilitySetting,
    setAccessibilitySetting,
} from "util/utils";
import DynamicKYCForm from "./components/DynamicKYCForm";
import { Answer, KYCForm } from "types";
import { getAllCountries } from "../../ducks/mortgage";
import { DynamicFormAPI, KYCQuestionType } from "types/enums";
import { mapCheckboxAnswers } from "util/kycUtils";

const styles = {
    subheadingWeight: {
        fontWeight: "200",
        fontSize: 20,
    },
    text: {
        marginBottom: 8,
        fontSize: "10px",
        color: "#646363",
    },
} as React.CSSProperties;

interface IProfilePageProps {}
interface IProfilePageReduxProps {
    name: string;
    phoneNumber: string;
    email: string;
    address: string;
    postalCode: string;
    hasCredentials: boolean;
    loading: boolean;
    city: string;
    username?: string;
    editProfile: boolean;
    kycLoading: boolean;
    kycForm?: KYCForm;
    kycInitialData?: KYCDataDto;
    kycLastChecked?: Date;
    forceShowForm?: boolean;
    iOrderBankPostAsPaperPost?: boolean;
}

interface IProfilePageDispatchProps {
    setHeader: (value: string) => void;
    setBackButton: (route: string) => void;
    hideBackButton: () => void;
    fetchProfile: () => void;
    removeLoginCredentials: () => Promise<string>;
    removeKeyCode: () => void;
    getPostalCity: (search: string) => void;
    displayToast: (msg: string) => void;
    toggleEditProfile: () => void;
    saveProfileData: (data: IProfileDataDto) => Promise<void>;
    saveKYCForm: (data: KycDto) => Promise<void>;
    fetchKYC: () => Promise<void>;
    fetchCountries: () => Promise<void>;
    fetchInitialData: () => Promise<void>;
    fetchAmlStatus: () => Promise<void>;
}

interface ProfilePageState {
    showConfirm: boolean;
    pinReseted: boolean;
    kycFormVisible: boolean;
    accessibilitySettingsVisible: boolean;
    accessibilitySettingsAllowed: boolean;
    kycSaving: boolean;
}

type ProfilePageProps = IProfilePageProps &
    IProfilePageReduxProps &
    IProfilePageDispatchProps &
    RouterProps;

type ProfilePagePropsWithStyles = ProfilePageProps &
    WithStyles<"subheadingWeight">;

class ProfilePage extends React.Component<
    ProfilePagePropsWithStyles,
    ProfilePageState
> {
    constructor(props: ProfilePagePropsWithStyles) {
        super(props);
        this.state = {
            showConfirm: false,
            pinReseted: false,
            kycFormVisible: props.forceShowForm ? props.forceShowForm : false,
            accessibilitySettingsVisible: false,
            accessibilitySettingsAllowed: false,
            kycSaving: false,
        };
    }

    async componentWillMount() {
        if (!this.props.loading) {
            this.props.fetchProfile();
        }
        if (!this.props.kycLoading) {
            await Promise.all([
                this.props.fetchKYC(),
                this.props.fetchCountries(),
                this.props.fetchInitialData(),
                this.props.fetchAmlStatus(),
            ]);
            const urlParams = new URLSearchParams(window.location.search);
            const showKyc = Boolean(urlParams.get("showKyc"));

            if (showKyc) {
                autoScroll("kycFormStartText");
            }
        }

        if (!this.props.city && this.props.postalCode) {
            this.props.getPostalCity(this.props.postalCode);
        }
    }

    componentDidMount() {
        this.props.setBackButton("/");
        this.props.setHeader("");
        const accessibilitySetting = getAccessibilitySetting();
        if (accessibilitySetting === "true") {
            this.setState({ accessibilitySettingsAllowed: true });
        }
    }

    componentWillUnmount() {
        this.props.hideBackButton();
        this.props.setHeader("");
    }

    render() {
        return this.renderDisplay();
    }

    renderDisplay() {
        const { classes, kycLastChecked } = this.props;
        const {
            kycFormVisible,
            accessibilitySettingsVisible,
            accessibilitySettingsAllowed,
        } = this.state;
        const namePaddingDisabled =
            this.props.username && !this.props.editProfile;

        return (
            <div>
                <div className="page-container" style={{ paddingTop: 18 }}>
                    <Grid container>
                        <Grid
                            item
                            style={{
                                position: "relative",
                                paddingBottom: namePaddingDisabled ? 0 : "8px",
                            }}
                            xs={8}
                        >
                            <Typography
                                style={{
                                    fontSize: "24px",
                                    color: "#004170",
                                    fontFamily: "Raleway",
                                }}
                            >
                                {this.props.name}
                            </Typography>
                        </Grid>
                        <Grid
                            item
                            style={{
                                position: "relative",
                                textAlign: "right",
                            }}
                            xs={4}
                        >
                            <IconButton
                                aria-label="Muokkaa"
                                color="primary"
                                onClick={() => {
                                    this.props.toggleEditProfile();
                                }}
                                style={{ height: 32, width: 32 }}
                            >
                                <CustomPenIcon
                                    editProfile={this.props.editProfile}
                                />
                            </IconButton>
                        </Grid>
                        {this.props.username && !this.props.editProfile && (
                            <Grid
                                item
                                xs={12}
                                style={{
                                    position: "relative",
                                    textAlign: "left",
                                    paddingTop: 0,
                                }}
                            >
                                <Typography
                                    style={{
                                        fontSize: "12px",
                                        color: "#A2A2A2",
                                        fontFamily: "Raleway",
                                    }}
                                >
                                    {this.props.username}
                                </Typography>
                            </Grid>
                        )}
                        {this.props.editProfile ? (
                            this.renderEditProfile()
                        ) : (
                            <Grid item xs={12}>
                                <Grid item style={{ position: "relative" }}>
                                    <Typography
                                        style={{
                                            fontFamily: "Arial",
                                            fontSize: "18px",
                                            color: "#646363",
                                        }}
                                        className={classes.subheadingWeight}
                                    >
                                        {this.props.email}
                                    </Typography>
                                </Grid>

                                <Grid item style={{ position: "relative" }}>
                                    <Typography
                                        style={{
                                            fontFamily: "Arial",
                                            fontSize: "18px",
                                            color: "#646363",
                                        }}
                                        className={classes.subheadingWeight}
                                    >
                                        {this.props.phoneNumber}
                                    </Typography>
                                </Grid>
                                <Grid item style={{ position: "relative" }}>
                                    <Typography
                                        style={{
                                            fontFamily: "Arial",
                                            fontSize: "18px",
                                            color: "#646363",
                                        }}
                                        className={classes.subheadingWeight}
                                    >
                                        {this.props.address &&
                                            `${this.props.address}, ${this.props.postalCode} ${this.props.city}`}
                                    </Typography>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                    <GridDivider />
                    <Grid container style={{ marginBottom: "10px", margin: 0 }}>
                        <Grid item xs={12} md={12} style={{ padding: 0 }}>
                            <Button
                                id="accessibilityOptionsButton"
                                fullWidth={true}
                                variant="flat"
                                style={{
                                    display: "flex",
                                    minHeight: "54px",
                                    padding: 0,
                                    textTransform: "none",
                                    justifyContent: "flex-start",
                                }}
                                onClick={() => {
                                    this.setState({
                                        accessibilitySettingsVisible: !this
                                            .state.accessibilitySettingsVisible,
                                    });
                                }}
                            >
                                <Grid
                                    item
                                    xs={10}
                                    md={10}
                                    style={{
                                        display: "flex",
                                        textAlign: "left",
                                    }}
                                >
                                    <Grid
                                        container
                                        style={{ padding: 0, margin: 0 }}
                                    >
                                        <Grid
                                            item
                                            xs={12}
                                            md={12}
                                            style={{ padding: 0 }}
                                        >
                                            <Typography
                                                style={{
                                                    fontSize: "22px",
                                                    color: "#646363",
                                                }}
                                            >
                                                Näkemisen helpottaminen
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={2} md={2}>
                                    <ArrowIcon
                                        orientation={
                                            accessibilitySettingsVisible
                                                ? ArrowIconOrientation.Up
                                                : ArrowIconOrientation.Down
                                        }
                                    />
                                </Grid>
                            </Button>
                        </Grid>
                    </Grid>
                    <Collapse in={accessibilitySettingsVisible}>
                        <Grid
                            container
                            style={{
                                marginTop: 0,
                                marginLeft: 0,
                                marginBottom: 20,
                                marginRight: 0,
                                padding: 0,
                                width: "100%",
                            }}
                        >
                            <Grid item xs={12} md={12} style={{ padding: 0 }}>
                                <Grid container style={{ padding: 0 }}>
                                    <Grid
                                        item
                                        xs
                                        md
                                        style={{
                                            padding: 0,
                                            display: "flex",
                                            alignItems: "flex-start",
                                            justifyContent: "center",
                                            flexGrow: 0,
                                        }}
                                    >
                                        <Checkbox
                                            id="accessibilitySettingsAllowedCheckbox"
                                            checked={
                                                accessibilitySettingsAllowed
                                            }
                                            onChange={this.handleCheckboxClick}
                                            icon={<CustomCheckboxIcon />}
                                            checkedIcon={
                                                <CustomCheckboxIconChecked />
                                            }
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        xs={10}
                                        md={10}
                                        style={{ paddingLeft: 0 }}
                                    >
                                        <label
                                            style={{
                                                fontSize: "18px",
                                                color: "#646363",
                                            }}
                                            htmlFor={
                                                "accessibilitySettingsAllowedCheckbox"
                                            }
                                        >
                                            Salli näytön suurentaminen ja kääntö
                                            vaaka-asentoon.
                                        </label>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Collapse>
                    <GridDivider />
                    <Grid
                        container
                        style={{
                            marginTop: 0,
                            marginLeft: 0,
                            marginBottom: 20,
                            marginRight: 0,
                            padding: 0,
                            width: "100%",
                        }}
                    >
                        <Grid item xs={12} md={12} style={{ padding: 0 }}>
                            <Grid container style={{ padding: 0 }}>
                                <Grid
                                    item
                                    xs
                                    md
                                    style={{
                                        padding: 0,
                                        display: "flex",
                                        alignItems: "flex-start",
                                        justifyContent: "center",
                                        flexGrow: 0,
                                    }}
                                >
                                    <Checkbox
                                        id="paperPostAllowedCheckbox"
                                        checked={
                                            this.props.iOrderBankPostAsPaperPost
                                        }
                                        onChange={
                                            this.toggleElectronicMarketing
                                        }
                                        icon={<CustomCheckboxIcon />}
                                        checkedIcon={
                                            <CustomCheckboxIconChecked />
                                        }
                                    />
                                </Grid>
                                <Grid
                                    container
                                    item
                                    xs={10}
                                    md={10}
                                    style={{ paddingLeft: 5 }}
                                    alignContent="center"
                                >
                                    <label
                                        style={{
                                            fontSize: "18px",
                                            color: "#646363",
                                        }}
                                        htmlFor={"paperPostAllowedCheckbox"}
                                    >
                                        Tilaan postin paperisena
                                    </label>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <GridDivider />
                    <Grid container>
                        {!this.props.hasCredentials && (
                            <Grid item xs={12} md={12}>
                                <Grid item xs={12} md={12}>
                                    <Typography>
                                        Luomalla kirjautumistunnukset voit
                                        jatkossa kirjautua palveluun käyttämällä
                                        näitä tunnuksia tai pankkitunnuksilla.
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Button
                                        color="primary"
                                        fullWidth={true}
                                        variant="flat"
                                        onClick={() =>
                                            this.props.history.push(
                                                "/eidentify/4"
                                            )
                                        }
                                        style={{ minHeight: "54px" }}
                                    >
                                        Luo kirjautumistunnukset
                                    </Button>
                                </Grid>
                            </Grid>
                        )}
                        {this.props.hasCredentials && (
                            <Grid container style={{ margin: 0, padding: 0 }}>
                                <Grid item xs={12} md={12}>
                                    {IsCordova && (
                                        <Grid item xs={12} md={12}>
                                            <Typography>
                                                Salasanan vaihdon jälkeen voit
                                                asettaa uuden tunnusluvun
                                                seuraavan kirjautumisen
                                                yhteydessä.
                                            </Typography>
                                        </Grid>
                                    )}
                                    <Grid item xs={12} md={12}>
                                        <Typography style={styles.text}>
                                            Poistamalla kirjautumistunnukset et
                                            voi enää kirjautua käyttäen
                                            tunnus-salasana yhdistelmää tai
                                            tunnuslukua, mutta voit kirjautua
                                            edelleen käyttäen pankkitunnuksia.
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <Button
                                            id="removeCredentials"
                                            color="primary"
                                            fullWidth={true}
                                            variant="flat"
                                            onClick={() =>
                                                this.setState({
                                                    ...this.state,
                                                    showConfirm: true,
                                                })
                                            }
                                            style={{ minHeight: "54px" }}
                                            className={"profile-page-button"}
                                        >
                                            Poista kirjautumistunnukset
                                        </Button>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Grid item xs={12} md={12}>
                                        <Button
                                            color="primary"
                                            fullWidth={true}
                                            variant="flat"
                                            onClick={() =>
                                                this.props.history.push(
                                                    "/eidentify/3"
                                                )
                                            }
                                            style={{ minHeight: "54px" }}
                                            className={"profile-page-button"}
                                        >
                                            Vaihda salasana
                                        </Button>
                                    </Grid>
                                </Grid>

                                {IsCordova &&
                                    localStorage.getItem("PassCodeSet") &&
                                    !this.state.pinReseted && (
                                        <Grid item xs={12} md={12}>
                                            <Button
                                                color="primary"
                                                fullWidth={true}
                                                variant="flat"
                                                onClick={() => {
                                                    clearSecureStorage();
                                                    this.setState({
                                                        ...this.state,
                                                        pinReseted: true,
                                                    });
                                                    this.props.displayToast(
                                                        "Tunnusluku nollattu"
                                                    );
                                                }}
                                                style={{ minHeight: "54px" }}
                                            >
                                                Nollaa tunnusluku
                                            </Button>
                                        </Grid>
                                    )}
                            </Grid>
                        )}
                    </Grid>
                    <GridDivider />
                    {this.props.kycLoading || this.state.kycSaving ? (
                        <Grid container>
                            <Grid
                                item
                                xs={12}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <CircularProgress />
                            </Grid>
                        </Grid>
                    ) : (
                        <>
                            <Grid container>
                                <Grid item xs={12}>
                                    <Button
                                        id="kyc-form-accordion"
                                        fullWidth={true}
                                        variant="flat"
                                        style={{
                                            minHeight: "54px",
                                            padding: 0,
                                            textTransform: "none",
                                        }}
                                        onClick={() =>
                                            this.setState(
                                                {
                                                    kycFormVisible: !kycFormVisible,
                                                },
                                                () => {
                                                    if (
                                                        this.state
                                                            .kycFormVisible
                                                    ) {
                                                        const elem = document.getElementById(
                                                            "customerRelationshipPurpose"
                                                        );

                                                        if (elem) {
                                                            elem.scrollIntoView(
                                                                {
                                                                    block:
                                                                        "end",
                                                                    behavior:
                                                                        "smooth",
                                                                    inline:
                                                                        "nearest",
                                                                }
                                                            );
                                                        }
                                                    }
                                                }
                                            )
                                        }
                                    >
                                        <Grid
                                            item
                                            xs={10}
                                            style={{ textAlign: "left" }}
                                        >
                                            <Grid item xs={12}>
                                                <Typography
                                                    style={{
                                                        fontSize: "22px",
                                                        color: "#646363",
                                                    }}
                                                >
                                                    Asiakkaan tuntemistiedot
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Typography
                                                    style={{
                                                        fontSize: "14px",
                                                        color: "#646363",
                                                    }}
                                                >
                                                    viimeksi tarkistettu{" "}
                                                    {kycLastChecked
                                                        ? moment(
                                                              kycLastChecked
                                                          ).format("DD.MM.YYYY")
                                                        : "-"}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={2}
                                            style={{
                                                alignSelf: "center",
                                                justifyContent: "center",
                                                textAlign: "right",
                                            }}
                                        >
                                            <ArrowIcon
                                                orientation={
                                                    kycFormVisible
                                                        ? ArrowIconOrientation.Up
                                                        : ArrowIconOrientation.Down
                                                }
                                            />
                                        </Grid>
                                    </Button>
                                </Grid>
                            </Grid>
                            <Collapse
                                in={kycFormVisible}
                                onEntered={() => {
                                    autoScroll("kycFormStartText");
                                }}
                            >
                                <Grid
                                    container
                                    style={{
                                        marginTop: 20,
                                        marginLeft: 0,
                                        marginBottom: 0,
                                        marginRight: 0,
                                        padding: 0,
                                        width: "100%",
                                    }}
                                >
                                    <Grid item xs={12} md={12}>
                                        <DynamicKYCForm
                                            form="kycform"
                                            onSubmit={async (values) =>
                                                await this.handleKycFormSubmit(
                                                    values
                                                )
                                            }
                                            initialValues={
                                                this.props.kycInitialData
                                            }
                                        />
                                    </Grid>
                                </Grid>
                            </Collapse>
                        </>
                    )}
                </div>
                <Dialog
                    open={this.state.showConfirm}
                    onClose={() =>
                        this.setState({ ...this.state, showConfirm: false })
                    }
                >
                    <DialogTitle id="responsive-dialog-title">
                        Oletko varma?
                    </DialogTitle>
                    <DialogContent>
                        <Typography>
                            Poistamalla kirjautumistunnukset et voi enää
                            kirjautua käyttäen tunnus-salasana yhdistelmää tai
                            tunnuslukua, mutta voit kirjautua edelleen käyttäen
                            pankkitunnuksia.
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() =>
                                this.setState({
                                    ...this.state,
                                    showConfirm: false,
                                })
                            }
                        >
                            Peruuta
                        </Button>
                        <Button
                            id="removeCredentials-confirm"
                            onClick={() =>
                                this.props.removeLoginCredentials().then(() => {
                                    this.props.fetchProfile();
                                    clearSecureStorage();
                                    this.setState({
                                        ...this.state,
                                        showConfirm: false,
                                    });
                                })
                            }
                        >
                            Ok
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }

    private readonly renderEditProfile = () => {
        return (
            <Grid container style={{ margin: "8px" }}>
                <EditProfileForm
                    form={editProfileFormName}
                    onSubmit={(values) => this.handleSubmit(values)}
                />
            </Grid>
        );
    };

    private readonly handleSubmit = async (data: any) => {
        let dto: IProfileDataDto = {
            email: data.email || "",
            phoneNumber: data.phoneNumber || "",
            streetAddress: data.streetAddress || "",
            postalCode: data.postalCode || "",
            hasLoginCredentials: false,
            iOrderBankPostAsPaperPost: this.props.iOrderBankPostAsPaperPost,
        };
        await this.props
            .saveProfileData(dto)
            .then(this.props.toggleEditProfile)
            .catch((err) => {
                this.props.displayToast(
                    "Virhe käyttäjätietojen tallennuksessa."
                );
            });
    };

    private readonly toggleElectronicMarketing = async (
        _event: React.ChangeEvent<HTMLInputElement>,
        checked: boolean
    ) => {
        let dto: IProfileDataDto = {
            email: this.props.email,
            phoneNumber: this.props.phoneNumber,
            streetAddress: this.props.address,
            postalCode: this.props.postalCode,
            hasLoginCredentials: false,
            iOrderBankPostAsPaperPost: checked,
        };

        await this.props
            .saveProfileData(dto)
            .then(() => this.props.displayToast("Tiedot päivitetty."))
            .catch((err) => {
                this.props.displayToast("Virhe tietojen tallennuksessa.");
            });
    };

    private readonly handleKycFormSubmit = async (data: KYCDataDto) => {
        const allQuestions: {
            id: string;
            name: string;
            answers?: Answer[];
            hasPredefinedAnswers: boolean;
            api?: DynamicFormAPI;
            questionType?: KYCQuestionType;
        }[] = [];

        if (this.props.kycForm) {
            for (const grp of this.props.kycForm.groups) {
                for (const question of grp.questions) {
                    allQuestions.push({
                        id: question.id.toString(),
                        name: question.name,
                        answers: question.answers,
                        hasPredefinedAnswers:
                            question.answers && question.answers.length !== 0,
                        api: question.api,
                        questionType: question.questionType,
                    });
                    if (question.additionalQuestions) {
                        for (const add of question.additionalQuestions) {
                            allQuestions.push({
                                id: add.id.toString(),
                                name: add.name,
                                answers: add.answers,
                                hasPredefinedAnswers:
                                    add.answers && add.answers.length !== 0,
                            });
                        }
                    }
                }
            }
        }

        const kycDto = {} as KycDto;
        const qa = [] as KycQuestionAnswer[];

        allQuestions.forEach((question) => {
            const answer = mapCheckboxAnswers(question, data);

            if (answer !== undefined) {
                // Add to Q&A list if destination API is IP
                if (question.api === DynamicFormAPI.IP) {
                    kycDto[question.name] = answer;
                } else {
                    const answerArr =
                        typeof answer === "string" ? [answer] : answer;
                    qa.push({
                        questionId: question.id,
                        answer: answerArr,
                    });
                }
            }
        });

        kycDto.questionsAndAnswers = qa;

        this.setState({ kycSaving: true });
        await this.props.saveKYCForm(kycDto);
        await this.props.fetchAmlStatus();
        await this.props.fetchInitialData();
        this.setState({ kycFormVisible: false, kycSaving: false });
    };

    private readonly handleCheckboxClick = (
        event: ChangeEvent<HTMLInputElement>
    ) => {
        setAccessibilitySetting(event.target.checked);
        this.setState({ accessibilitySettingsAllowed: event.target.checked });
    };
}

const mapStateToProps = (state: ReduxState): IProfilePageReduxProps => {
    const postalCodes = getPostalCodes(state);
    let city = "";

    if (postalCodes && state.profile.postalCode) {
        const pc = postalCodes.find(
            (item) => item.postalCode === state.profile.postalCode
        );
        if (pc) {
            city = pc.postalCityFi;
        }
    }
    return {
        name: `${state.profile.firstName || ""} ${
            state.profile.lastName || ""
        }`,
        phoneNumber: state.profile.phoneNumber || "",
        email: state.profile.email || "",
        address: state.profile.streetAddress || "",
        postalCode: state.profile.postalCode || "",
        city: city,
        hasCredentials: state.profile.hasLoginCredentials,
        loading: state.profile.loading,
        username: state.profile.userName,
        editProfile: state.profile.editProfile,
        kycLoading: state.kyc.loading,
        kycForm: state.kyc.form,
        kycInitialData: state.kyc.initialData,
        kycLastChecked:
            state.profile.amlStatus && state.profile.amlStatus.latestAnswerDate,
        forceShowForm:
            state.profile.amlStatus &&
            (state.profile.amlStatus.amlRiskAssesmentStatusType ===
                AmlRiskAssesmentStatusType.Optional ||
                state.profile.amlStatus.amlRiskAssesmentStatusType ===
                    AmlRiskAssesmentStatusType.Required),
        iOrderBankPostAsPaperPost: state.profile.iOrderBankPostAsPaperPost,
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): IProfilePageDispatchProps => {
    return {
        setHeader: (value: string) => {
            dispatch(SetHeader(value));
        },
        setBackButton: (route: string) => {
            dispatch(ShowBackNavigationWithRoute(route));
        },
        hideBackButton: () => {
            dispatch(SetShowBackNavigation(false));
        },
        fetchProfile: () => {
            dispatch(fetchProfileData());
        },
        removeLoginCredentials: async () => {
            return await dispatch(removeLoginCredentials());
        },
        removeKeyCode: () => {},
        getPostalCity: (search: string) => {
            dispatch(autoCompletePostalCity(search));
        },
        displayToast: (str: string) => {
            dispatch(showSnackbar(str));
        },
        toggleEditProfile: () => {
            dispatch(toggleEditProfile());
        },
        saveProfileData: async (data: IProfileDataDto) => {
            dispatch(saveProfileData(data));
        },
        saveKYCForm: async (data: KycDto) => {
            await dispatch(saveKYCData(data));
        },
        fetchKYC: async () => {
            await dispatch(fetchKYCData());
        },
        fetchCountries: async () => {
            await dispatch(getAllCountries());
        },
        fetchInitialData: async () => {
            await dispatch(getInitialKycData());
        },
        fetchAmlStatus: async () => {
            await dispatch(getAmlStatus());
        },
    };
};

export default connect<
    IProfilePageReduxProps,
    IProfilePageDispatchProps,
    IProfilePageProps
>(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(ProfilePage));



// WEBPACK FOOTER //
// ./src/views/profile/ProfilePage.tsx